const Gender = {
  FEMALE: 1,
  MALE: 2
};

export default Gender;
